import { createSelector } from '@reduxjs/toolkit';

import { createMappingByKey } from '@paragon/production-app-utilities';

import { RootState } from '../slices';

export const getBundlesByProductionGroupGuid = createSelector(
  (state: RootState) => state.bundles,
  (state: RootState) => state.productionGroups,

  (bundles, productionGroups) => createMappingByKey(bundles, (bundle) => bundle.productionGroupGuid, productionGroups),
);
